import type { AxiosRequestConfig } from 'axios'

export interface RequestFilter<T = AxiosRequestConfig> {
  doFilter(request: T, chain: RequestFilterChain): void
}

export default class RequestFilterChain<T = AxiosRequestConfig> {
  private filters: Array<RequestFilter<T>>
  private index: number

  constructor(filters: Array<RequestFilter<T>>) {
    this.filters = filters ? filters : []
    this.index = 0
  }

  doFilter(request: T, chain: RequestFilterChain) {
    if (this.index == this.filters.length) {
      return
    }

    const filter = this.filters[this.index]

    this.index++

    filter.doFilter(request, chain)
  }
}
